import RowTracker from '../models/rowTracker';
export type Seat = {
  isBlocked: boolean;
  isOccupied: boolean;
  prefix: string;
  index: number;
};

export class RowBitmap {
  static getSeats({
    capacity,
    rbitmap,
    str_blocked_rbitmap,
    str_rbitmap,
    prefix,
    blocked_rbitmap,
  }: RowTracker): Seat[] {
    const seats: Seat[] = Array(capacity);

    if (!str_rbitmap || !str_blocked_rbitmap) {
      let rb = rbitmap;
      let bb = blocked_rbitmap;
      for (let i = 0; i < capacity; i++, rb = rb >> 1, bb = bb >> 1) {
        const isBlocked = Boolean(bb & 1);
        const isOccupied = Boolean(rb & 1);
        seats[i] = { isOccupied, isBlocked, prefix, index: i + 1 };
      }
    } else {
      str_rbitmap.split('').forEach((bit, index) => {
        const isBlocked = str_blocked_rbitmap[index] === '1';
        const isOccupied = bit === '1';

        seats[index] = { isOccupied, isBlocked, prefix, index: index + 1 };
      });
    }

    return seats;
  }

  static blockSeat(rbitmap: number | string, index: number) {
    if (typeof rbitmap === 'number') {
      const x = 1 << index;
      rbitmap = rbitmap | x;

      return rbitmap;
    }

    const arrblocked_rbitmap = rbitmap.split('');
    arrblocked_rbitmap[index] = '1';
    return arrblocked_rbitmap.join('');
  }

  static freeSeat(rbitmap: number | string, index: number) {
    if (typeof rbitmap === 'number') {
      return rbitmap & ~(1 << index);
    }

    const arrblocked_rbitmap = rbitmap.split('');
    arrblocked_rbitmap[index] = '0';
    return arrblocked_rbitmap.join('');
  }

  static isFree(rbitmap: number | string, index: number) {
    if (typeof rbitmap === 'number') {
      return (rbitmap & (1 << index)) === 0;
    } else {
      return rbitmap[index] === '0';
    }
  }
}
